import { Divider, Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getToken } from "../../../../../middleware/storage";
import { addValidatedStep, setSubmissionDetails } from "../topupSlice";
import AgreementCheckboxes from "./agreement_checkboxes";
import PaymentDetailListingRegistered from "./payement_details_registered"; 
import PaymentDetailListing from "./payment_detail_listing";
import TxnDetailListing from "./txn_details_listing";
import AddressBillingDetailListing from "./billing_address_detail_listing";


const useStyles = makeStyles((theme) => ({
  root: { border: `1px solid ${theme.palette.secondary.main}` },
  header: {
    color: "#FFF",
    background: theme.palette.secondary.main,
    padding: 10,
    textAlign: "center",
  },
}));

function TxnConfirmation(props) {
  const classes = useStyles();

  const {
    txnDetails,
    paymentDetails,
    submissionDetails,
    providers,
    setSubmissionDetails,
    addressDetails,
    countries,
    showCCForm,
  } = props;
  const { errors, activeStep, cCards, vat } = useSelector((state) => state.topup);
  function getProviderName(id) {
    const provider = providers.find((p) => p.providerId === id);
    return provider ? provider.name : "";
  }

  function getCardDetails(id) {
    const card = cCards.find((c) => c.customerCardId === id);
    return card;
  }
  const [loggedIn, SetLogin] = useState(false);
  useEffect(() => {
    async function validateLogin() {
      const token = getToken();
      if (!token) {
        SetLogin(false);
      } else {
        SetLogin(true);
      }
    }

    validateLogin();
  }, []);

  const [submissionDetailsState, updateSubmissionDetails] = useState(
    submissionDetails
  );

  const dispatch = useDispatch();
  const handleChange = (prop) => (event) => {
    setSubmissionDetails({
      ...submissionDetailsState,
      [prop]: event.target.checked,
    });
    updateSubmissionDetails({
      ...submissionDetailsState,
      [prop]: event.target.checked,
    });
    dispatch(addValidatedStep(activeStep));
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" className={classes.header}>
            Top Up Confirmation Summary
          </Typography>
        </Grid>
        <Grid item sm={4} xs={12}>
          <Divider />
          <TxnDetailListing
            values={txnDetails}
            getProviderName={getProviderName}
            vat={vat}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Divider />
          {loggedIn ? (
            showCCForm ? (
              <PaymentDetailListing values={paymentDetails} />
            ) : (
              <PaymentDetailListingRegistered
                values={getCardDetails(paymentDetails.customerCardId)}
              />
            )
          ) : (
            <PaymentDetailListing values={paymentDetails} />
          )}
        </Grid>
        <Grid item sm={4} xs={12}>
          <Divider />
          <AddressBillingDetailListing
            values={addressDetails}
            countries={countries}
          />
        </Grid>
        <Grid item xs={12}>
          <Divider />
          <AgreementCheckboxes
            values={submissionDetailsState}
            error={errors.agreement}
            handleChange={handleChange}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

const mapStateToProps = (state) => ({
  ...state.topup,
  addressDetails: state.topup.addressDetails,
  countries: state.topup.countries
});

const mapDispatch = { setSubmissionDetails };

export default connect(mapStateToProps, mapDispatch)(TxnConfirmation);
